interface Rating {
    appStore: number
    appStoreCount: number
    playStore: number
    playStoreCount: number
}
export const  storeRating = () => {
    return <Rating>{
        appStore: 4.8,
        appStoreCount: 24,
        playStore: 4.2,
        playStoreCount: 843, 
    }
};